import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { makeSelectAllowSignIn } from 'containers/Main/selectors';
import Divider from 'components/Divider';
import Rating from 'components/Rating';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Grid from '@material-ui/core/Grid';
import Popper from '@material-ui/core/Popper';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import SaveAsFavorite from 'components/SaveAsFavorite';
import Share from 'components/Share';
import { getFormattedType } from 'components/ResourceItemSelector/utils';
import MixPanel from 'utils/mixpanelService';
import DotIcon from './images/dots.svg';

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    right: 0,
  },
  icon: {
    height: 20,
  },
  ratingWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  rootContent: {
    background: '#fff',
    padding: 20,
  },
  buttonRoot: {
    ...theme.typography.body2,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  downIcon: {
    color: theme.palette.primary.contrastText,
  },
  popper: {
    zIndex: 999,
    width: 340,
    border: `1px solid #E9ECED`,
    boxShadow: '0 2px 14px 0 rgba(0,0,0,0.05)',
    '&[x-placement*="bottom"] $arrow': {
      top: 0,
      left: 0,
      marginTop: '-1em',
      width: '3em',
      height: '1em',
      '&::before': {
        borderWidth: '0 1em 1em 1em',
        borderColor: `transparent transparent #E9ECED transparent`,
      },
    },
  },
  arrow: {
    position: 'absolute',
    fontSize: 7,
    width: '3em',
    height: '3em',
    '&::before': {
      content: '""',
      margin: 'auto',
      display: 'block',
      width: 0,
      height: 0,
      borderStyle: 'solid',
    },
  },
  btn: {
    width: '100%',
    margin: '6px 0',
    backgroundColor: 'white',
    height: 48,
    border: `1px solid #E3E3E3`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 30.5,
  },
  shareWrapper: {
    marginTop: 8,
    '& > div': {
      display: 'flex',
      justifyContent: 'center',
      '& span': {
        display: 'block',
        textAlign: 'center',
        ...theme.typography.caption,
      },
    },
  },
  textArea: {
    borderColor: '#E9ECED',
    borderRadius: 2,
    marginBottom: 11,
    width: '100%',
    padding: '5px 18px',
    marginTop: 15,
  },
  reviewButton: {
    background: '#01619B',
    borderRadius: 2,
    height: 29,
    width: 82,
    fontSize: 12,
    fontFamily: 'MadaBold',
    color: '#fff',
  },
  submitBtnWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  successMessage: {
    color: '#1F8E1D',
    paddingTop: 12,
    display: 'block',
  },
});

class ResourcePageActions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      arrowRef: null,
      review: '',
      showReviewMessage: false,
    };
    this.reviewSent = false;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { review } = this.props;
    if (!_isEmpty(nextProps.review) && review !== nextProps.review) {
      this.setState({
        review: nextProps.review.review,
        showReviewMessage: this.reviewSent,
      });
      setTimeout(() => this.setState({ showReviewMessage: false }), 4000);
    }
  }

  handleRatingClick = (value, newValue) => {
    this.props.rate(newValue);
  };

  handleReviewSubmit = e => {
    e.preventDefault();

    const { sendReview, data, review: fullReview } = this.props;
    const { review } = this.state;
    const {
      fields: { name, title, blog, type: resourceSubtype },
      sys,
    } = data[0];
    const type = getFormattedType(sys.contentType.sys.id);
    let subtype;
    if (type === 'app') {
      if (resourceSubtype === 'Online Therapy') subtype = resourceSubtype;
      else subtype = 'Apps';
    }
    if (type === 'organization') {
      subtype = resourceSubtype;
    }
    if (type === 'read') {
      subtype = resourceSubtype;
    }
    MixPanel.track('Review This', {
      name: name || title,
      type,
      blog,
      subtype,
      review,
      rating: _get(fullReview, 'rating') || 0,
    });
    this.reviewSent = true;
    sendReview(review);
  };

  handleToggle = () => {
    const { open } = this.state;
    const { data } = this.props;
    const {
      fields: { name, title, type },
    } = data[0];
    this.setState({ open: !open, showReviewMessage: false }, () => {
      if (this.state.open) {
        MixPanel.track('Write a Review - Clicked', {
          name: name || title,
          path: window.location.pathname,
          type,
        });
      }
    });
  };

  handleClose = event => {
    if (this.anchorEl.contains(event.target)) {
      return;
    }
    this.setState({ open: false });
  };

  handleArrowRef = node => {
    this.setState({
      arrowRef: node,
    });
  };

  render() {
    const {
      classes,
      id,
      isAdmin,
      saved,
      save,
      data,
      allowSignIn,
      saveToList,
      review: fullReview,
    } = this.props;
    const { sys, fields } = data[0];
    const contentType = _get(sys, 'contentType.sys.id');
    const hideReview = ['organization', 'person'].includes(contentType);
    const { open, arrowRef, review, showReviewMessage } = this.state;
    const ratingValue = fullReview ? fullReview.rating : 0;
    return (
      <div className={classes.root}>
        <IconButton
          buttonRef={node => {
            this.anchorEl = node;
          }}
          aria-owns={open ? 'menu-list-grow' : undefined}
          aria-haspopup="true"
          onClick={this.handleToggle}
          classes={{ root: classes.buttonRoot }}
          disableRipple
          disableTouchRipple
          aria-label="Page Action Button"
        >
          <img src={DotIcon} alt="" />
        </IconButton>
        <Popper
          open={open}
          anchorEl={this.anchorEl}
          className={classes.popper}
          transition
          disablePortal
          placement="bottom-end"
          modifiers={{
            arrow: {
              enabled: true,
              element: arrowRef,
            },
          }}
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              id="menu-list-grow"
              style={{
                transformOrigin:
                  placement === 'bottom' ? 'center top' : 'center bottom',
              }}
            >
              <>
                <span className={classes.arrow} ref={this.handleArrowRef} />
                <ClickAwayListener onClickAway={this.handleClose}>
                  <Grid container className={classes.rootContent}>
                    {allowSignIn && !hideReview && (
                      <>
                        <Grid item xs={12}>
                          <Grid
                            container
                            direction="row"
                            justify="space-between"
                          >
                            <Grid item xs={6}>
                              <Typography
                                variant="overline"
                                color="textPrimary"
                              >
                                Leave A Review
                              </Typography>
                            </Grid>
                            <Grid item xs={6} className={classes.ratingWrapper}>
                              <Rating
                                name={`${contentType}-rating`}
                                value={ratingValue}
                                precision={0.5}
                                readOnly={false}
                                onChange={this.handleRatingClick}
                                isBig
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        {showReviewMessage && (
                          <Grid item xs={12}>
                            <Typography
                              variant="overline"
                              className={classes.successMessage}
                            >
                              Your review has been successfully submitted!
                            </Typography>
                          </Grid>
                        )}
                        {ratingValue > 0 && (
                          <>
                            <Grid item xs={12}>
                              <textarea
                                value={review}
                                onChange={e =>
                                  this.setState({ review: e.target.value })
                                }
                                placeholder="Write a review (Optional)"
                                cols={40}
                                rows={5}
                                className={classes.textArea}
                              />
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              className={classes.submitBtnWrapper}
                            >
                              <Button
                                onClick={this.handleReviewSubmit}
                                className={classes.reviewButton}
                              >
                                Send
                              </Button>
                            </Grid>
                          </>
                        )}
                        <Grid item xs={12}>
                          <Divider top={18} bottom={18} />
                        </Grid>
                      </>
                    )}
                    <Grid item xs={12}>
                      <SaveAsFavorite
                        id={id}
                        isAdmin={isAdmin}
                        saved={saved}
                        save={save}
                        withText
                      />
                    </Grid>

                    <Grid item xs={12}>
                      {allowSignIn && (
                        <Grid item xs={12}>
                          <IconButton
                            className={classes.btn}
                            disableRipple
                            onClick={saveToList}
                          >
                            <Typography variant="overline" color="textPrimary">
                              SAVE TO LIST
                            </Typography>
                          </IconButton>
                        </Grid>
                      )}
                    </Grid>
                    <Grid item xs={12} className={classes.shareWrapper}>
                      <Share
                        data={fields}
                        type={getFormattedType(sys.contentType.sys.id)}
                      />
                    </Grid>
                  </Grid>
                </ClickAwayListener>
              </>
            </Grow>
          )}
        </Popper>
      </div>
    );
  }
}

ResourcePageActions.propTypes = {
  allowSignIn: PropTypes.bool,
  classes: PropTypes.object,
  data: PropTypes.array,
  rate: PropTypes.func,
  rating: PropTypes.object,
  review: PropTypes.object,
  saveToList: PropTypes.func,
  sendReview: PropTypes.func,
  id: PropTypes.string,
  isAdmin: PropTypes.bool,
  saved: PropTypes.bool,
  save: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  allowSignIn: makeSelectAllowSignIn(),
});

const withConnect = connect(mapStateToProps);

export default compose(
  withStyles(styles),
  withRouter,
  withConnect,
)(ResourcePageActions);
